import React, { useEffect, useState } from 'react'
import "./profile.css"
import Footer from '../../Home/Home_modules/Footerr/footer'
import { Link, BrowserRouter as Router, useHistory, Redirect } from "react-router-dom";
import { getAuth } from "firebase/auth";
import firebase from '@firebase/app-compat';
import firebaseConfig from '../../fire.js';
import { toast } from "react-toastify";
import ImageUploader from 'react-images-upload';
import 'firebase/compat/storage';
import ShareButton from "react-web-share-button";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { set } from 'react-ga';
import './cardmenu.css'


const divStyle = {
    borderColor: 'white',
    backgroundColor:'#000014',
    borderRadius: '50px',
    color: 'white',
   
  };

function Profile_pg() {
    const [ userData, setUserData ] = useState(null);
    const [ userDoc, setUserDoc ] = useState('');
    const [ avatar, setAvatar ] = useState(null);
    const [editCover, setEditCover] = useState(false);
    const [editAvatar, setEditAvatar] = useState(false);
    const walletaddress = localStorage.getItem('LAST_ACTIVE_ACCOUNT')
    if (!walletaddress) {
        toast.error("Please connect wallet");
        console.log(walletaddress)
    }

    function editprofile() {
      //  toast.warn("Edit profile fails to load, please try again.")
        window.location.href ="./edit_profile";
      }

    firebaseConfig.auth().onAuthStateChanged(function(user) {

        if(user) {
           //Here you can place the code that you want to run if the user is logged in
        } else {
           window.location.href = "../login";
        }
        
        });
    let history = useHistory();
    
    const auth = getAuth();
    const user = auth.currentUser;
    if (user) {
        // User is signed in, see docs for a list of available properties
        // https://firebase.google.com/docs/reference/js/firebase.User
        // ...
        var uid = user.uid;
    } else {
  // No user is signed in.
    }


const [allBiddata, setAllBiddata] = useState([]);
const [allPurchases, setAllPurchases] = useState([]);
const [allPurchasedNFT, setAllPurchasedNFT] = useState([]);
const [onSaleData, setOnSaleData] = useState([]);

 function removenftOpen(){
     document.querySelector('.remove-nft').classList.add('remove-nft-active')
 }
 function removenftClose(){
     document.querySelector('.remove-nft').classList.remove('remove-nft-active')
 }
 function removeNftPopupOpen(){
     document.querySelector('.remove-nft-pop').classList.add('remove-nft-pop-active')
     document.querySelector('.remove-nft-pop-inner').classList.add('remove-nft-pop-inner-active')
 }
 function removeNftPopupClose(){
     document.querySelector('.remove-nft-pop').classList.remove('remove-nft-pop-active');
        document.querySelector('.remove-nft-pop-inner').classList.remove('remove-nft-pop-inner-active');
 }


useEffect(() => {
    const Purchases = firebase.firestore().collection('purchases').where('uid', '==', getAuth().currentUser.uid).get({ source: 'server' }).then(response => {
       //console.log('all NFTs here', response.docs)
        response.docs.forEach(value => {
          //console.log('Each nft data', value.data())
            // if (value.data().uid == getAuth().currentUser.uid) {
                if (allPurchases.findIndex(item => item.timestamp == value.data().timestamp) == -1) {
                allPurchases.push(value.data())
                }
            // }
        })
        
    }).catch(error => {
        setAllPurchases([])
      //  console.log('Getting all NFTs Call fail', error)
    })


    const userData = firebase.firestore().collection('users').where('uid', '==', getAuth().currentUser.uid).get({ source: 'server' }).then(res => {
        if (res.docs.length  == 1) {
      //  console.log('user details here', res.docs[0].data())
      //  this.setState({userdata: res.docs[0].data()});
       // console.log("User data Fetch:",this.state.userdata);
        //console.log(this.state.userdata.value);
        setUserData(res.docs[0].data())
        setUserDoc(res.docs[0].id)
        
        if (res.docs[0].data().avatar !== undefined && res.docs[0].data().avatar.length > 0) {
            // setAvatar(res.docs[0].data().avatar)
            setEditAvatar(false)
        } else {
            setEditAvatar(true)
        }
        if (res.docs[0].data().cover !== undefined && res.docs[0].data().cover.length > 0) {
            // setAvatar(res.docs[0].data().avatar)
            setEditCover(false)
        } else {
            setEditCover(true)
        }
    } else {
        
    }
    }).catch(err => {
        console.log('Something went wrong in user details API', err)
    })
    
   const bidData = new Array();
   const bids = firebase.firestore().collection('bids')
   .where('uid', '==', getAuth().currentUser.uid).get({ source: 'server' }).then(response => {
        // console.log('all NFTs here', response.docs)
        response.docs.forEach(value => {
          //  console.log('Each Bid data', value.data())
          //  console.log('Each Bid data', value.data().nft)
            
                        


            // if (value.data().uid == getAuth().currentUser.uid) {
                if (allBiddata.findIndex(item => item.TxId == value.data().TxId) == -1) {
                bidData.push(value.data())
                }
                
                
            // }
        })
        localStorage.setItem('BidData', JSON.stringify(bidData))
        setAllBiddata(JSON.parse(localStorage.getItem('BidData')))
        
        
    }).catch(error => {
        setAllBiddata([])
     //   console.log('Getting all Bids Call fail', error)
    }
    )
    const walletAddress = localStorage.getItem('LAST_ACTIVE_ACCOUNT')
    const onsaleData = new Array();
    const onSaleItems = firebase.firestore()
                                .collection('metadata');
                                const snapshot = onSaleItems.where('fromaddress', '==', walletaddress).get();
                                snapshot.then(response => {
                                    response.docs.forEach(value => {
                                    console.log(value.id, '=>', value.data());
                                    if (onSaleData.findIndex(item => item.TokenID == value.data().TokenID) == -1) {
                                        onsaleData.push(value.data())
                                    }
                                     
                                    }) 
                                   
                                })
                                localStorage.setItem('OnSaleData', JSON.stringify(onsaleData))
                                setOnSaleData(JSON.parse(localStorage.getItem('OnSaleData')))
                          //  console.log('OnSaleData', onSaleData)    
    

    return Purchases && bids
    

}, []);
//console.log(allBiddata)
//console.log(onSaleData)

    return (
        <Router>
        <div className="profile-page">

            <div className='remove-nft-pop'>
                <div className='remove-nft-pop-inner'>
                    <h2>Do you want to remove the nft from marketplace ?</h2>
                    <div className='remove-nft-pop-btns'>
                        <button className='remove-nft-pop-open-btn'>Yes</button>
                        <button onClick={()=>removeNftPopupClose()} className='remove-nft-pop-close-btn'>No</button>
                        </div>
                    </div>
                </div>
            <div className="profile-page-banner">
            {editCover || (userData == null || userData.cover == undefined) ?  <ImageUploader
                // withIcon={true}
                singleImage={true}
                // defaultImage={avatar}
                fileContainerStyle={{
                    height: 260,
                    width: '100%',
                    borderRadius: 16,
                    backgroundColor: '#cccccc'
                }}
                className={"profile-page-banner img"}
                // withPreview={true}
                // accept={'accept=image/*'}
                buttonText={'Upload Cover Picture'}
                buttonStyles={{
                    width: '100%',
                    alignSelf: 'baseline'
                }}
                onChange={(picture) => {
                    console.log('image details', picture[0])
                    const uploadImage = firebase.storage().refFromURL('gs://diginoor-3755e.appspot.com/covers/'+getAuth().currentUser.uid).put(picture[0],{contentType: picture[0].type}).then(response => {
                        response.ref.getDownloadURL().then(object => {
                        console.log('Image uploaded to firebase storage', object)
                        // setAvatar(object)
                            firebase.firestore().collection('users').doc(userDoc).update({
                                'cover': object
                            }).then(response1 => {
                                console.log('User avatar stored on db', response1)
                                setAllPurchases([])
                            }).catch(error => {
                                console.log('Failed to store avatar on db', error)
                            })
                        })
                    }).catch(error => {
                        console.log('image upload tp firebase storage fail', error)
                    })
                    // setAvatar(picture)
                }}
                labelStyles={null}
                label={null}
                imgExtension={['.jpg', '.png', '.jpeg']}
                maxFileSize={5242880}
            />
        :
        <img onClick={() => setEditCover(true)} src={userData.cover} />
        }
            </div>
            <div className="profile-section-top">
               {editAvatar || (userData == null || userData.avatar == undefined) ? <ImageUploader
                // withIcon={true}
                singleImage={true}
                // defaultImage={avatar}
                className={"profile-section-top img"}
                fileContainerStyle={{
                    backgroundColor: '#ffffff',
                    height: 135,
                    width: 135,
                    // borderWidth: 5,
                    // borderColor: '#000',
                    borderRadius: 25,
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    display: 'block',
                }}
                // withPreview={true}
                // accept={'accept=image/*'}
                buttonText={'Upload Profile Picture'}
                buttonStyles={{
                    width: '100%',
                    alignSelf: 'baseline'
                }}
                onChange={(picture) => {
                    console.log('image details', picture[0])
                    const uploadImage = firebase.storage().refFromURL('gs://diginoor-3755e.appspot.com/avatars/'+getAuth().currentUser.uid).put(picture[0],{contentType: picture[0].type}).then(response => {
                        response.ref.getDownloadURL().then(object => {
                        console.log('Image uploaded to firebase storage', object)
                        // setAvatar(object)
                            firebase.firestore().collection('users').doc(userDoc).update({
                                'avatar': object
                            }).then(response1 => {
                                console.log('User avatar stored on db', response1)
                                setAllPurchases([])
                            }).catch(error => {
                                console.log('Failed to store avatar on db', error)
                            })
                        })
                    }).catch(error => {
                        console.log('image upload tp firebase storage fail', error)
                    })
                    // setAvatar(picture)
                }}
                label={null}
                imgExtension={['.jpg', '.png', '.jpeg']}
                maxFileSize={5242880}
            />
        :
        <img onClick={() => setEditAvatar(true) } src={userData.avatar} />
       
        }
               <h3>{userData !== null && userData !== undefined && userData.name}</h3>
                <p className="user-profile-address">{walletaddress}
               
                </p>
              {/*   <div className="followr-count">
                    <div><p className="user-followers-count">24 followers</p></div>
                    <div><p className="user-following-count">30 following</p></div>
                </div>*/}
                <div className="user-profile-options">
                    <div><button onClick={editprofile} className="user-profile-edit-btn">Edit Profile</button></div>
                    <div><button className="user-profile-share-btn" ><ShareButton buttonStyle={divStyle}/></button></div><br></br>
                    <div><button className="user-profile-options-btn"><i className="fas fa-ellipsis-h"></i></button></div>
                </div>
               
            </div>
            <Tabs>
    <TabList>
      <Tab>Bids</Tab>
      <Tab>Showcase</Tab>
      <Tab>On Sale</Tab>
      <Tab>Activity</Tab>
    </TabList>
    <TabPanel>
        
            <div className="user-profile-showcase">
            <div className="about-showcase">
                {allBiddata.length > 0 && allBiddata.map((item) => {
                    // console.log(item.nft)
                    return (  <div key={item.TxId} className={
                        item.nft.collection=="Rare" ? "rare-card showcase-card" 
                        : item.nft.collection =="Legendary" ? "legendary-card showcase-card"
                        : item.nft.collection =="Ultimate" ? "ultimate-card showcase-card" 
                        : "showcase-card"}>
                        <button className="showcase-lo"></button>
                        <button className="showcase-lo"></button>
                        <button className="showcase-lo"></button>
                        <div className="showcase-top-dot-menu">
                            <button className="showcase-top-dot"></button>
                            <button className="showcase-top-dot"></button>
                            <button className="showcase-top-dot"></button>
                            </div>
                            <div className="showcase-card-im" onClick={() => {
                                history.push("/nftdetail/" + item.nftid);
                                }}>
                                    <img className="showcase-card-image" src={item.nft.nft_thumb} alt="Logo" />
                                    </div>
                                    <div className="showcase-top-details">
                                        <p className="showcase-top-card-title" onClick={() => {
                                            history.push("/nftdetail/" + item.nftid);
                                            }}>{item.nft.nft_title}</p>
                                            <p className="showcase-top-card-title1">{item.nft.collection}</p>
                                            <p className="showcase-top-card-title-price" onClick={() => {
                                                history.push("/nftdetail/" + item.nftid);
                                                }}>{item.nft.price} MATIC</p>
                                                </div>
                                                <div className="like">
                                                    <span className="glyphicon showcase-gly glyphicon-heart-empty"> </span>
                                                    </div>
                                                    </div>)
                                                }
                                                )
                                                }
                                                </div>
                                                </div>
    </TabPanel>
    <TabPanel>
        <div className="user-profile-showcase">
            <div className="about-showcase">
                {allPurchases.length > 0 && allPurchases.map((item) => {
                    return (  <div key={item.timestamp} className={
                        item.nft.collection=="Rare" ? "rare-card showcase-card" 
                        : item.nft.collection =="Legendary" ? "legendary-card showcase-card"
                        : item.nft.collection =="Ultimate" ? "ultimate-card showcase-card" 
                        : "showcase-card"}>
                        <button className="showcase-lo"></button>
                        <button className="showcase-lo"></button>
                        <button className="showcase-lo"></button>
                        <div className="showcase-top-dot-menu">
                            <button className="showcase-top-dot"></button>
                            <button className="showcase-top-dot"></button>
                            <button className="showcase-top-dot"></button>
                            </div>
                            <div className="showcase-card-im" onClick={() => {
                                history.push("/nftshowcase/" + item.nft._id);
                                }}>
                                    <img className="showcase-card-image" src={item.nft.nft_thumb} alt="Logo" />
                                    </div>
                                    <div className="showcase-top-details">
                                        <p className="showcase-top-card-title" onClick={() => {
                                            history.push("/nftshowcase/" + item.nft._id);
                                            }}>{item.nft.nft_title}</p>
                                            <p className="showcase-top-card-title1">{item.nft.collection}</p>
                                            <p className="showcase-top-card-title-price" onClick={() => {
                                                history.push("/nftshowcase/" + item.nft._id);
                                                }}>{item.nft.price}</p>
                                                </div>
                                                <div className="like">
                                                    <span className="glyphicon showcase-gly glyphicon-heart-empty"> </span>
                                                    </div>
                                                    </div>)
                                                }
                                                )
                                                }
                                                </div>
                                                </div>
                                                
    </TabPanel>
    <TabPanel>
    <div className="user-profile-showcase">
            <div className="about-showcase">
                {onSaleData.length > 0 && onSaleData.map((item) => {
                    
                    return (  <div key={item.TokenID} className="showcase-card" >
                        <button className="showcase-lo"></button>
                        <button className="showcase-lo"></button>
                        <button className="showcase-lo"></button>
                        <div className="showcase-onsale-dot-menu">
                        <div className="showcase-card-dropdown">
                            <span>...</span>
                            <div className="showcase-card-dropdown-content">
                                <p onClick={()=> removeNftPopupOpen()} className="showcase-card-dropdown-item">remove nft</p> 
                            </div>
                        </div>
                            </div>
                            <div className="showcase-card-im"  onClick={() => {
                                history.push("/nftshowcase/" );
                                }}  >
                                    <img className="showcase-card-image" src={item.nft.nft_thumb} alt="Logo" />
                                    </div>
                                    <div className="showcase-top-details">
                                        <p className="showcase-top-card-title" onClick={() => {
                                            history.push("/nftshowcase/");
                                            }}>{item.nft.nft_title}</p>
                                            <p className="showcase-top-card-title1">{item.nft.collection}</p>
                                            <p className="showcase-top-card-title-price" onClick={() => {
                                                history.push("/nftshowcase/");
                                                }}>{item.NFTUpdatedPrice}</p>
                                                </div>
                                                <div className="like">
                                                    <span className="glyphicon showcase-gly glyphicon-heart-empty"> </span>
                                                    </div>
                                                    <div onClick={()=> removeNftPopupOpen()}className='remove-nft'>
                                                        <div>
                                                    <p>x</p>
                                                    <p>remove</p>
                                                    </div>
                                                        </div>
                                                    </div>)
                                                }
                                                )
                                                }
                                                </div>
                                                </div>
    </TabPanel>
    <TabPanel>
    <div className="user-profile-tab4"  style={{paddingBottom: '100px'}}>
    <div className="recent-activity-scroll">
    {allBiddata.length > 0 && allBiddata.map((item) => {
            
            return (
      
            <div key = {item.nft} className="recent-activity-grid">
                {/*<h2>Nothing Found</h2>*/}
            <div><img className="activity-user-image" />
            </div>
            <div>
                <h4 className="activity-title"><span>Bid on</span> <b>{item.nft_title}</b></h4>
                <p className="activity-date"><a href={` https://polygonscan.com/tx/${item.TxId}`} target="_blank">View Transaction</a></p>
            </div>
            <div>
                <h4 className="activity-detail">{item.value} ETH</h4>
</div>
            </div> 
        
       
        )
        })}
        <div className="activity-tag-cloud">
            <button className="tag-cloud-btns">likes</button>
            <button className="tag-cloud-btns">bids</button>
            <button className="tag-cloud-btns">auctions</button>
            <button className="tag-cloud-btns">sold</button>
            <button className="tag-cloud-btns">followers</button>
            <button className="tag-cloud-btns">following</button>
        </div>
        </div>
        </div>
    </TabPanel>
  </Tabs>
        </div>
        <Footer />
        </Router>
    )
}

export default Profile_pg
